import type { FC } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { ErrorScreen } from '@components/ErrorScreen/ErrorScreen';
import { Button } from '@reverse-hr/design-system';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '@app/constants/navigation';

export const ErrorScreenExpiredLink: FC = () => {
  const { t } = useTranslation('', {
    keyPrefix: 'login.expiredLink',
  });

  const navigate = useNavigate();

  const title = t('title');
  const ctaLabel = t('cta');

  const onLinkClick = (): void | Promise<void> => navigate(ROUTES.LOGIN);

  return (
    <ErrorScreen className="c-error-screen--expired-link" title={title}>
      <p className="c-error-screen__subtitle">
        <Trans
          i18nKey="login.expiredLink.description"
          components={{ strong: <strong /> }}
        />
      </p>

      <div className="c-error-screen__cta">
        <Button onClick={onLinkClick}>{ctaLabel}</Button>
      </div>
    </ErrorScreen>
  );
};
